/** `patients.id` for /practices/:practiceId/patients/:patientId — never chart `patient_id` (MRN). */
export function resolvePatientRecordId(patient) {
  if (!patient) return null;
  const tableId = patient.patient_table_id ?? patient.patients_table_id;
  if (tableId != null && String(tableId).trim() !== '') return tableId;

  // Follow-up query rows: `id` is the note PK; `patient_id` is patients.id
  const isFollowUpResultRow = Object.prototype.hasOwnProperty.call(patient, 'fu_note_content');
  if (isFollowUpResultRow) {
    const followUpPatientId = patient.patient_id;
    if (followUpPatientId != null && String(followUpPatientId).trim() !== '') {
      return followUpPatientId;
    }
  }

  const pid = patient.id;
  if (pid == null || pid === '') return null;
  return pid;
}

/** Practice id for patient detail route (row data or active lookup practice). */
export function resolvePatientPracticeId(patient, fallbackPracticeId) {
  const fromRow = patient?.practice_id ?? patient?.practiceId;
  if (fromRow != null && String(fromRow).trim() !== '') {
    return String(fromRow).trim();
  }
  const fb = fallbackPracticeId != null ? String(fallbackPracticeId).trim() : '';
  if (fb && fb !== 'all') return fb;
  return null;
}

export function buildPatientDetailsPath(practiceId, patientId) {
  if (!practiceId || patientId == null) return null;
  return `/practices/${practiceId}/patients/${patientId}`;
}
